import { useEffect, useState } from 'react';
import type { AnyActorRef, SnapshotFrom } from 'xstate';

export function useFieldActorSnapshot(
  actor: AnyActorRef | null | undefined,
): SnapshotFrom<AnyActorRef> | null {
  const [snapshot, setSnapshot] = useState<SnapshotFrom<AnyActorRef> | null>(
    () => actor?.getSnapshot() ?? null,
  );

  useEffect(() => {
    if (!actor) {
      setSnapshot(null);
      return;
    }
    setSnapshot(actor.getSnapshot());
    const sub = actor.subscribe(setSnapshot);
    return () => sub.unsubscribe();
  }, [actor]);

  return snapshot;
}
